<template>
  <router-view />
  <ToastHost />
</template>

<script setup>
import ToastHost from "@/components/common/ToastHost.vue";
</script>
